module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('search-box'), _vm._v(" "), (!_vm.search_data != '') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.search_data != '') ? _c('h4', {
    staticClass: "grey"
  }, [_vm._v("Products found in " + _vm._s(_vm.search_data))]) : _vm._e(), _vm._v(" "), (_vm.products.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("no matching products")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  }))]), _vm._v(" "), _c('active-products')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27f470d4"}!./src/pages/Search/template.html
// module id = 253
// module chunks = 0